import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import OrderAddressSearchComponent from "../../components/order/OrderAddressSearchComponent.tsx";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import {useParams} from "react-router-dom";

export default function LargeAccountOrderPage() {
    const {customer_id} = useParams()

    ScrollToTop()
    setTitleAndMetaDescription('Bestil til storkunde', 'Bestil ny forbindelse til storkunde')

    return (
        <section className="blurb">
            <h1 className="heading heading--blue heading--big">Bestilling til storkunde</h1>
            <p>Opret ny kunde under storkunde ({customer_id})</p>
            <OrderAddressSearchComponent autofocus={true} notSticky={true} largeAccountCustomerId={customer_id}/>
        </section>
    )
}
